(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

$(document).ready(function () {
    controlVacancies();

    function controlVacancies() {

        function getUsa() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=usa", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#usaTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            })
        }
        function getArg() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=argentina", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#arTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }
        function getCa() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=canada", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#canadaTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }
        function getNo() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=norway", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#norwayTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }
        function getBy() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=belarus", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#byTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }
        function getPl() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=poland", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#polandTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }
        function getOther() {
            $.get( "https://www.altoros.com/api/jobs/get/jobs?country=other", function( data ) {
                let result = JSON.parse(data);
                let index = 0;
                for (const element of result) {
                    index += 1;
                    $('#otherTab').find('.collapse_custom').append('<li data-colapse="' + index + '" data-id="' + element.vacancy_id + '"><div class="collapsible-header"><h3>' + element.title + '</h3></div><div class="collapsible-body"><div class="collapsible-body__content"><div class="collapsible-body__left-part">' + element.desc.body + '</div><div class="collapsible-body__right-part">' + element.hr + '</div></div></div></li>')
                }
            });
        }


        $.when(getUsa(), getArg(), getCa(), getNo(), getPl(),getOther()).done(setTimeout(function () {
            controlVacancyFromUrl();
        },4000));
    };

    controlVacancyFromUrl();
    function controlVacancyFromUrl() {
        var activeTabVacancy;
        var vacancyActiveId;
        var colapseId;

        if (window.location.hash == "") {
            activeTabVacancy = '#usaTab';
            window.location.hash = activeTabVacancy;
        } else {
            var data = window.location.hash.split('?');
            activeTabVacancy = data[0];
            $('.s-tabs-vacancies .tabs').tabs('select', activeTabVacancy.slice(1));
            if (data[1]) {
                vacancyActiveId = +data[1].slice(10);
                $('.collapsible li').each(function () {
                    if ($(this).attr('data-id') == vacancyActiveId) {
                        colapseId = $(this).attr('data-colapse');
                    }
                });
                $('' + activeTabVacancy + ' .collapsible').collapsible('open', (colapseId - 1));
                $('html, body').animate({
                    scrollTop: $('' + activeTabVacancy + ' li.active').offset().top - 120
                }, 500);
            }
        }

        $('.tab a').on('click', function (e) {
            e.preventDefault();
            var x = window.pageXOffset,
                y = window.pageYOffset;
            $(window).one('scroll', function () {
                window.scrollTo(x, y);
            })
        });

        $('.s-tabs-vacancies .tab').on('click', function (e) {
            activeTabVacancy = $(this).find('a').attr('href');
            window.location.hash = activeTabVacancy;
        });

        $('.s-tabs-vacancies .collapsible').collapsible({
            onOpenEnd: function(el){
                vacancyActiveId = $(el).attr('data-id');
                window.location.hash = activeTabVacancy + '?vacancyId=' + vacancyActiveId;
            }
        });
    }


});
},{}]},{},[1])